import React from "react";

import { ConfigureDestinationsModal } from "../../modals/ConfigureDestinationsModal";
import { DestinationConfigRow } from "../shared/ConfigPageRow";

const CredentialsModal = ({ destination, open, onClose, existingConfig }) => {
  const settings = existingConfig.settings || {};

  return (
    <ConfigureDestinationsModal
      limitSettings={[]}
      open={open}
      includeHeader={true}
      settings={settings}
      dest={destination}
      onClose={onClose}
      existingConfig={existingConfig}
    />
  );
};

const CredentialsRow = ({ setConfigModalOpen }) => {
  return (
    <DestinationConfigRow
      name="Credentials"
      labelText="Instructions"
      onOpenConfigModal={() => setConfigModalOpen("credentials")}
    />
  );
};

const ConfigurationModal = ({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
  existingConfig,
}) => {
  const settings = existingConfig.settings || {};

  return (
    <ConfigureDestinationsModal
      limitSettings={["eventTopicMappings"]}
      open={open}
      settings={settings}
      dest={destination}
      onClose={onClose}
      onSave={(_dest, _id, newConfig) => handleUpdateConfigureDest(newConfig)}
      existingConfig={existingConfig}
    />
  );
};

const ConfigurationRow = ({ setConfigModalOpen }) => {
  return (
    <DestinationConfigRow
      name="Mappings"
      labelText="Mappings"
      onOpenConfigModal={setConfigModalOpen}
    />
  );
};

const CREDENTIALS = "CREDENTIALS";
const OPTIONS = "OPTIONS";

const Rows = {
  CREDENTIALS: CredentialsRow,
  OPTIONS: ConfigurationRow,
};

const Modals = {
  CREDENTIALS: CredentialsModal,
  OPTIONS: ConfigurationModal,
};

const RowOrder = [CREDENTIALS, OPTIONS];

export default {
  Rows,
  RowOrder,
  Modals,
};
